import { initI18n } from '@agos/shared'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './index.css'
import { reloadOnWorkerTakeover } from './reload-on-worker-takeover'

// Before the first render. Without it `tt()` returns its argument, which happens to look right because
// the source strings are Slovak — so a missing `initI18n` is invisible until somebody switches language
// and nothing changes.
initI18n()

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('index.html is missing the #root mount point')

// §9.357, FB-640 - a customer arriving from the old system is controlled by legacy's service
// worker, which serves a document naming a bundle AGOS does not have. Our worker claims the page,
// but claiming does not reload it, so the stale tab stays stale. Once per tab.
reloadOnWorkerTakeover()

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
